<script>
  import { slide } from 'svelte/transition';
  import Wysiwyg from '$lib/default/Wysiwyg.svelte';

  export let item;

  $: offset = item.id < 10 ? `0${item.id}` : item.id;

  let open = false;
</script>

<div class="faq__item">
  <button
    class="faq__question-block"
    class:active={open}
    on:click={() => {
      open = !open;
    }}
  >
    <span class="faq__question-number">{offset}</span>
    <p>{item.question}</p>
    <i class="isax isax-arrow-down-1 faq__question-icon" />
  </button>
  {#if open}
    <div class="faq__answer" transition:slide>
      <Wysiwyg content={item.answer} />
    </div>
  {/if}
</div>

<style lang="scss">
  .faq {
    &__item {
      padding: 3rem 3rem 3rem 9.2rem;
      background-color: rgb(var(--white));
      --black: 0, 0, 0;
      box-shadow: 3px 3px rgba(var(--black), 0.02);
      border-radius: 5px;
      transition: all 0.2s;
      position: relative;

      @include resp-max('xs') {
        padding: 3rem 1rem 3rem 5.2rem;
      }

      &::after {
        content: '';
        border-right: 1.5px solid var(--aqua-1);
        height: 2.6rem;
        position: absolute;
        top: 3rem;
        left: 6.6rem;

        @include resp-max('xs') {
          left: 3.6rem;
        }
      }

      &:not(:first-child) {
        margin-top: 1.3rem;
      }
    }

    &__question-block {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      width: 100%;
      cursor: pointer;

      &.active {
        .faq__question-icon {
          transform: rotateX(180deg);
        }
      }
    }

    &__question-number {
      color: var(--royal-light);
      font-size: 1.6rem;
      line-height: 1.6;
      position: absolute;
      left: 3rem;

      @include resp-max('xs') {
        left: 1rem;
      }
    }

    &__question-icon {
      align-self: center;
      font-weight: 900;
      transition: transform 0.2s;
      pointer-events: none;
    }

    &__answer {
      color: var(--royal-light);
      padding-top: 2rem;
    }
  }
</style>
